import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject } from '@angular/core';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { InvoiceService } from '@app/core/services/models/invoice.service';
import { BaseUrlService } from '@app/core/services/base-url.service';
import { ToastService } from '@app/core/services/toast.service';
import { primengImports } from '@app/core/primeng';

@Component({
  selector: 'app-invoices-preview',
  standalone: true,
  imports: [
    CommonModule,
    PdfViewerModule,
    ...primengImports
  ],
  templateUrl: './invoices-preview.component.html',
  styleUrl: './invoices-preview.component.scss'
})
export class InvoicesPreviewComponent implements OnInit, OnDestroy {
  private baseUrl = inject(BaseUrlService);

  record: any = null;
  invoiceRef: string | null = null;
  pdfUrlRaw: string | null = null;
  pdfBlobUrl: string | null = null;

  invoiceUuid: string | null = null;

  loading = false;
  loadingPdf = false;

  constructor(
    private route: ActivatedRoute,
    private invoiceService: InvoiceService,
    private toastService: ToastService,
    private http: HttpClient
  ) {}

  ngOnDestroy() {
    if (this.pdfBlobUrl) {
      URL.revokeObjectURL(this.pdfBlobUrl);
      this.pdfBlobUrl = null;
    }
  }

  ngOnInit() {
    this.configurePdfWorker();
    this.invoiceUuid = this.route.snapshot.paramMap.get('uuid');
    if (this.invoiceUuid) {
      this.loadInvoice();
    } else {
      this.toastService.show('Facture introuvable', 'error');
    }
  }

  configurePdfWorker() {
    const pdfjsVersion = '4.8.69';
    const workerUrl = `https://cdn.jsdelivr.net/npm/pdfjs-dist@${pdfjsVersion}/legacy/build/pdf.worker.min.mjs`;
    if (typeof window !== 'undefined' && (window as any).pdfjsLib) {
      (window as any).pdfjsLib.GlobalWorkerOptions.workerSrc = workerUrl;
    }
  }

  loadInvoice() {
    if (!this.invoiceUuid) return;

    this.loading = true;
    this.invoiceService.getByUuid(this.invoiceUuid).subscribe({
      next: (invoice: any) => {
        this.record = invoice;

        this.invoiceRef = invoice.invoice_ref;
        
        // Get invoice_ref for PDF URL
        this.invoiceRef = invoice.invoice_ref;
        const invoiceUrl = invoice.pdf_url;
        
        // Build PDF URL: pdf-invoices/{invoice_ref}.pdf
        // Encode special characters (e.g., # becomes %23)
        if (this.invoiceRef) {
          const encodedInvoiceRef = (invoiceUrl ?? '');
          this.pdfUrlRaw = `${this.baseUrl.uploadPath}/pdf/${encodedInvoiceRef}`;
          // Load PDF as blob to avoid CORS issues
          this.loadPdfAsBlob();
        }

        this.loading = false;
      },
      error: (err) => {
        console.error('Error loading invoice:', err);
        this.toastService.show('Erreur lors du chargement de la facture', 'error');
        this.loading = false;
      }
    });
  }

  loadPdfAsBlob() {
    if (!this.pdfUrlRaw) return;

    this.loadingPdf = true;
    if (this.pdfBlobUrl) {
      URL.revokeObjectURL(this.pdfBlobUrl);
      this.pdfBlobUrl = null;
    }

    this.http.get(this.pdfUrlRaw, {
      responseType: 'blob',
      headers: new HttpHeaders({ 'Accept': 'application/pdf' })
    }).subscribe({
      next: (blob: Blob) => {
        this.pdfBlobUrl = URL.createObjectURL(blob);
        this.loadingPdf = false;
      },
      error: (err) => {
        console.error('Error loading PDF:', err);
        this.toastService.show('Erreur lors du chargement du PDF', 'error');
        this.loadingPdf = false;
      }
    });
  }

  downloadPDF() {
    if (!this.pdfUrlRaw) return;
    window.open(this.pdfUrlRaw, '_blank');
  }
}
